import { CustomWindow } from '@utils/models/customwindow';
declare let window: CustomWindow;

// 🌐 Translations
const translations = {
  en: {
    heading: "Alphabetical navigation",
    label: (letter: string) => `Go to section ${letter}`
  },
  sv: {
    heading: "Alfabetisk navigering",
    label: (letter: string) => `Gå till avsnitt ${letter}`
  }
};

const htmlLang = document.documentElement.lang.toLowerCase();
const currentLang = htmlLang.startsWith("sv") ? "sv" : "en";
const t = translations[currentLang];

function normalizeLetterAnchors(containerSelector: string = ".letter-anchor-links"): void {
  const containers = document.querySelectorAll<HTMLElement>(containerSelector);

  containers.forEach((container) => {
    container.setAttribute("aria-labelledby", "letter-nav-heading");

    // Add visually hidden heading (if not already present)
    if (!document.getElementById("letter-nav-heading")) {
      const heading = document.createElement("h2");
      heading.id = "letter-nav-heading";
      heading.className = "sr-only";
      heading.textContent = t.heading;
      container.prepend(heading);
    }

    // Create <ul> for the alphabet
    const list = document.createElement("ul");
    list.className = "letter-anchor-links__letter-list";
    list.setAttribute("role", "list");

    const childNodes = Array.from(container.childNodes).filter(
      (node) => node.nodeType !== Node.ELEMENT_NODE || (node as Element).tagName !== "H2"
    );

    childNodes.forEach((node) => {
      const li = document.createElement("li");
      li.setAttribute("role", "listitem");

      // Linked letters
      if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === "A") {
        const anchor = node as HTMLAnchorElement;
        const letter = anchor.textContent?.trim().replace("\u00A0", "") ?? "";
        anchor.textContent = letter;
        anchor.classList.add("letter-anchor-links__letter");
        anchor.setAttribute("aria-label", t.label(letter));
        li.appendChild(anchor);
        list.appendChild(li);
      }

      // Empty text nodes (e.g. &nbsp;)
      else if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim() === "") {
        return;
      }

      // Plain text letters (not links)
      else if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
        const text = node.textContent!;
        Array.from(text).forEach((char) => {
          if (char.trim()) {
            const span = document.createElement("span");
            span.textContent = char;
            span.classList.add("letter-anchor-links__letter", "letter-anchor-links__letter--disabled");
            span.setAttribute("aria-hidden", "true");
            span.setAttribute("tabindex", "-1");

            const item = document.createElement("li");
            item.setAttribute("role", "listitem");
            item.appendChild(span);
            list.appendChild(item);
          }
        });
      }
    });

    // Remove old children (except heading)
    Array.from(container.childNodes).forEach((node) => {
      if (!(node as HTMLElement).id?.startsWith("letter-nav-heading")) {
        container.removeChild(node);
      }
    });

    container.appendChild(list);
  });
}

// Cookiebot load
window.CookiebotCallback_OnLoad = () => {
  normalizeLetterAnchors();

  // Keyboard support: jump to anchor
  document.addEventListener("keydown", (e) => {
    const key = e.key.toUpperCase();
    const target = document.querySelector(`.letter-list a[href="#${key}"]`) as HTMLAnchorElement;
    if (target) {
      e.preventDefault();
      target.focus();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
};